import { render, staticRenderFns } from "./Foundation.vue?vue&type=template&id=4d476a2d&scoped=true"
import script from "./Foundation.vue?vue&type=script&lang=js"
export * from "./Foundation.vue?vue&type=script&lang=js"
import style0 from "./Foundation.vue?vue&type=style&index=0&id=4d476a2d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d476a2d",
  null
  
)

export default component.exports